import { createRoute, redirect, useParams } from '@tanstack/react-router';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';
import { useAdminCourse } from '../../../../hooks/useAdminCourses.js';
import { AdminPageHeader } from '../../../../components/admin/AdminPageHeader.js';
import { CourseForm } from '../../../../components/admin/CourseForm.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/courses/$courseId',
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role;
    if (role !== 'super_admin') throw redirect({ to: '/app' });
  },
  component: EditCoursePage,
});

function EditCoursePage() {
  const { courseId } = useParams({ from: '/app/admin/courses/$courseId' });
  const { data, isLoading, error } = useAdminCourse(courseId);

  if (isLoading) return <p className="text-muted">Loading…</p>;
  if (error)
    return (
      <p className="text-danger bg-danger-bg border border-danger/30 rounded-lg px-4 py-3">
        {(error as Error).message}
      </p>
    );
  if (!data) return null;

  return (
    <div>
      <AdminPageHeader
        title={data.course.name}
        description={`${data.course.providerName}${data.course.cricosCode ? ` · CRICOS ${data.course.cricosCode}` : ''}`}
        backTo="/app/admin/courses"
        backLabel="All courses"
      />
      <CourseForm initial={data.course} />
    </div>
  );
}
